<template>
  <div>
    <div class="popUp">
      <p @click="show = true">
        <span>筛选</span>
        <img src="../../../assets/bx/dj/sx.png" alt="" />
      </p>
    </div>
    <div class="pop-content">
      <van-popup v-model="show" closeable close-icon="close">
        <div class="content">
          <p :class="{ isActive: activeIndex == null }" @click="chooseAll">全部</p>
          <p v-for="(item, i) in popList" :key="item.id" :class="{ isActive: activeIndex === i }" @click="changeTag(i)">
            {{ item.name }}
          </p>
        </div>
        <div class="confirmBtn" @click="showTagList">确定</div>
      </van-popup>
    </div>

    <!-- 列表内容 -->
    <van-empty v-if="tagList.length == 0 && content">暂无内容</van-empty>

    <div v-else>
      <div class="openList" v-for="item in tagList" :key="item.id" @click="gotoGame(item.id)">

        <!-- <div class="time">08:00</div> -->
        <div class="list">
          <img :src="item.icon" alt="" />
          <div class="list-content">
            <h3>{{ item.app_name }}</h3>
            <!-- <span class="title">热血战斗游戏</span> -->
            <p v-html="replaceAll(item.intro)"></p>
          </div>
          <!-- <div class="button">启动</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "openList",
    data() {
      return {
        show: false,
        popList: [],
        activeIndex: null,
        tagList: [],
        name: '',
        keyword: "",
        content: false
      };
    },
    created() {},
    mounted() {
      this.getTagContent();
      this.showPopup();
    },
    methods: {
      replaceAll(str){
        if(str) {
          return str.replace(new RegExp('&nbsp;','g'),'');
        }else {
          return ''
        }
      },
      chooseAll() {
        this.activeIndex = null
        this.keyword = ''
      },
      // 切换tag
      changeTag(i) {
        this.activeIndex = i
        this.name = this.popList[i].name
      },

      // 展示弹出层获取tag
      showPopup() {
        this.$Ajax("game/tags", {}, "get").then((rs) => {
          if (rs.code === 200) {
            this.popList = rs.data;
          }
        });
      },
      // 获取默认tag
      getTagContent(keyword) {
        this.$Ajax("/game/list", {
          keyword
        }, "get").then(
          (rs) => {
            if (rs.code === 200) {
              this.content = true
              this.tagList = rs.data;
              this.content = true
            }
          }
        );

      },
      // 点击popUp的确认按钮
      showTagList() {
        if(this.activeIndex != null) {
          this.keyword = this.name
        }else {
          this.keyword = null
        }
        this.getTagContent(this.keyword);
        this.show = false;
      },
      gotoGame(app_id) {
        this.$router.push({
          name: 'detail',
          query: {
            app_id
          }
        })
      }
    },
  };
</script>

<style scoped lang="less">
  .popUp {
    display: flex;
    justify-content: flex-end;
    margin-right: 1rem;
    padding-top: 1rem;

    p {
      color: #949393;
      font-size: 1.5rem;
      cursor: pointer;

      img {
        width: 1.5rem;
        height: 1.5rem;
        margin-left: 0.2rem;
        vertical-align: text-top;
      }
    }
  }

  .pop-content {
    position: relative;

    .content {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: 5rem;
      margin-left: 1.5rem;
      max-height: 15rem;
      overflow-y: auto;

      p {
        height: 2.8rem;
        background-color: #eef1f6;
        border-radius: 2.5rem;
        text-align: center;
        line-height: 2.8rem;
        margin: 0.6rem;
        padding: 0 0.65rem;
      }

      .isActive {
        background: #fe5547;
        color: white;
      }
    }

    .confirmBtn {
      // position: absolute;
      // left: 50%;
      // bottom: 1rem;
      // transform: translate(-50%, -50%);
      background: #fe5547;
      color: white;
      font-size: 1.3rem;
      width: 8rem;
      height: 2.8rem;
      border-radius: 1.85rem;
      text-align: center;
      line-height: 3rem;
      display: block;
      margin: 1rem auto 0;
    }
  }

  /deep/.van-popup--center {
    width: 30rem;
    padding-bottom: 2rem;
    // height: 25rem;
    background: white;
    border-radius: 0.8rem;
  }

  .openList {
    padding: 1rem;
    background: white;
    margin: 1rem;
    border-radius: 0.85rem;

    .time {
      display: flex;
      justify-content: center;
      color: #fe5547;
      font-size: 1.5rem;
      margin: 0.5rem 0;
    }

    .list {
      display: flex;
      // justify-content: space-between;
      align-items: center;

      img {
        width: 5rem;
        height: 5rem;
        margin-right: 1rem;
      }

      .list-content {
        h3 {
          margin-bottom: 0.5rem;
        }
        .title {
          color: #cdcdcd;
        }

        p {
          color: #bebebe;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          /deep/img,
          /deep/.img,
          /deep/.image {
            display: none;
          }
        }
      }

      .button {
        width: 7rem;
        height: 2.5rem;
        background: #fe5547;
        color: white;
        text-align: center;
        line-height: 2.5rem;
        // margin-right: 5.2rem;
        border-radius: 2.5rem;
        font-size: 1.45rem;
      }
    }
  }
</style>